import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import ClientRequirementForm from "@/pages/ClientRequirementForm";

export const Route = createFileRoute("/client-requirement")({ head: () => routeMeta('Share Your Property Requirement | MNRE', 'Tell MNRE what property you need and receive relevant options from our team.', '/client-requirement'), component: ClientRequirementForm });
